// src/app/redux/actions/sallesActions.js

export const SET_SALLES_LOADING = "SET_SALLES_LOADING";
export const SET_SALLES_ERROR = "SET_SALLES_ERROR";

export const FETCH_SALLES_REQUEST = "FETCH_SALLES_REQUEST";
export const FETCH_SALLES_SUCCESS = "FETCH_SALLES_SUCCESS";
export const FETCH_SALLES_FAIL = "FETCH_SALLES_FAIL";

export const CREATE_SALLE_REQUEST = "CREATE_SALLE_REQUEST";
export const CREATE_SALLE_SUCCESS = "CREATE_SALLE_SUCCESS";
export const CREATE_SALLE_FAIL = "CREATE_SALLE_FAIL";

export const UPDATE_SALLE_REQUEST = "UPDATE_SALLE_REQUEST";
export const UPDATE_SALLE_SUCCESS = "UPDATE_SALLE_SUCCESS";
export const UPDATE_SALLE_FAIL = "UPDATE_SALLE_FAIL";

export const DELETE_SALLE_REQUEST = "DELETE_SALLE_REQUEST";
export const DELETE_SALLE_SUCCESS = "DELETE_SALLE_SUCCESS";
export const DELETE_SALLE_FAIL = "DELETE_SALLE_FAIL";

export const setSallesLoading = (v) => ({ type: SET_SALLES_LOADING, payload: v });
export const setSallesError = (msg) => ({ type: SET_SALLES_ERROR, payload: msg });

export const fetchSallesRequest = () => ({ type: FETCH_SALLES_REQUEST });
export const fetchSallesSuccess = (data) => ({ type: FETCH_SALLES_SUCCESS, payload: data });
export const fetchSallesFail = (err) => ({ type: FETCH_SALLES_FAIL, payload: err });

export const createSalleRequest = (payload) => ({ type: CREATE_SALLE_REQUEST, payload });
export const createSalleSuccess = (data) => ({ type: CREATE_SALLE_SUCCESS, payload: data });
export const createSalleFail = (err) => ({ type: CREATE_SALLE_FAIL, payload: err });

export const updateSalleRequest = (id, payload) => ({
    type: UPDATE_SALLE_REQUEST,
    payload: { id, payload },
});
export const updateSalleSuccess = (data) => ({ type: UPDATE_SALLE_SUCCESS, payload: data });
export const updateSalleFail = (err) => ({ type: UPDATE_SALLE_FAIL, payload: err });

export const deleteSalleRequest = (id) => ({ type: DELETE_SALLE_REQUEST, payload: { id } });
export const deleteSalleSuccess = (id) => ({ type: DELETE_SALLE_SUCCESS, payload: id });
export const deleteSalleFail = (err) => ({ type: DELETE_SALLE_FAIL, payload: err });
